// Environment configuration for Vite
// Vite automatically exposes environment variables prefixed with VITE_

/**
 * Derives a gallery URL from the API URL when no explicit gallery URL is provided.
 * Returns explicitGalleryUrl if non-empty, otherwise extracts the domain from
 * apiUrl (e.g., https://api.dev.flywideopen.com/v1 → https://gallery.dev.flywideopen.com).
 * Falls back to empty string for localhost or non-matching URLs.
 */
export function deriveGalleryUrl(apiUrl: string, explicitGalleryUrl: string): string {
  if (explicitGalleryUrl) {
    return explicitGalleryUrl
  }

  const match = apiUrl.match(/^https:\/\/api\.(.+?)(?:\/|$)/)
  if (match) {
    return `https://gallery.${match[1]}`
  }

  return ''
}

export const config = {
  apiUrl: import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001',
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    region: import.meta.env.VITE_AWS_REGION || 'eu-west-2',
  },
  galleryUrl: deriveGalleryUrl(import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001', import.meta.env.VITE_GALLERY_URL || ''),
  portalUrl: import.meta.env.VITE_PORTAL_URL || 'https://pilots.dev.flywideopen.com',
  competitionResultsUrl: import.meta.env.VITE_COMPETITION_RESULTS_URL || '',
  albatrossUrl: import.meta.env.VITE_ALBATROSS_URL || 'https://albatross.flywideopen.com/api',
  albatrossCompId: import.meta.env.VITE_ALBATROSS_COMP_ID || '',
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
  isDevelopment: import.meta.env.NODE_ENV === 'development',
  isProduction: import.meta.env.NODE_ENV === 'production',
} as const

// Validate required environment variables
const requiredEnvVars = [
  'VITE_API_URL',
  'VITE_COGNITO_USER_POOL_ID', 
  'VITE_COGNITO_CLIENT_ID',
  'VITE_AWS_REGION',
] as const

export function validateEnvironment(): void {
  const missing = requiredEnvVars.filter(
    (key) => !import.meta.env[key]
  )
  
  if (missing.length > 0) {
    console.warn(
      `Missing environment variables: ${missing.join(', ')}\n` +
      'Please check your .env.local file and ensure all required variables are set.'
    )
  }
}

// Validate on module load in development
if (config.isDevelopment) {
  validateEnvironment()
}